import { CdkStepperModule } from "@angular/cdk/stepper";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { AlertModule as CosoAlertModule } from "@coso/alert";
import { ConnectionFormsModule } from "@coso/connection-forms";
import { EnvironmenterModule } from "@coso/environmenter";
import { FormsModule as CosoFormsModule } from "@coso/forms";
import { WizardModule as CosoWizardModule } from "@coso/wizard";
import { AlertModule } from "ngx-bootstrap/alert";
import { WizardRoutingModule } from "./wizard-routing.module";
import { WizardComponent } from "./wizard.component";

@NgModule({
  declarations: [WizardComponent],
  imports: [CommonModule, WizardRoutingModule, CosoWizardModule, CdkStepperModule, ReactiveFormsModule, CosoFormsModule, ConnectionFormsModule, EnvironmenterModule, CosoAlertModule, AlertModule]
})
export class WizardModule {}
